import React, { Component } from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import BackNextButtons from './BackNextButtons';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import axios from "axios";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import 'react-multi-carousel/lib/styles.css';
import { ElectricityIcon, LPGIcon, NaturalGasIcon, BroadbandIcon, PhoneIcon  } from '../includes/Icons';
import BuildBroadband  from '../includes/BuildBroadband';
import BuildPhone  from '../includes/BuildPhone';
import BuildElectricity from '../includes/BuildElectricity';
import BuildLPG from '../includes/BuildLPG';
import BuildGas from '../includes/BuildGas';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
            </IconButton>
        ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
root: {
    padding: theme.spacing(2),
},
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
root: {
    margin: 0,
    padding: theme.spacing(1),
},
}))(MuiDialogActions);

const availableText ={
    color: "#7FB8BB",
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: "0",
    position: "absolute",
    bottom: "20px",
}
const notAvailableText={
    fontSize: "1.3rem",
    fontWeight:"600"
}
const responsive = {
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2,
      paritialVisibilityGutter: 50
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 50
    }
};

const tickIcon = <img src="resources/themes/pulse-energy/images/icons/Tick.png" />;  

/**
 * get address parameter from URL
 * get icp from address
 * load address and icp into selectedICP()
 */
const param = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});
let type = param.type;

export default function Services(props) {
    const [open, setOpen] = React.useState(false);
    const [isChecked, setIsChecked] = React.useState(false);
    const [broadbandServices, setBroadbandServices] = React.useState(props.values.broadbandArray);
    const [selectedServices, setSelectedServices] = React.useState(props.values.servicesArray);
    const [broadbandStatus, setBroadbandStatus] = React.useState(true);
    const [lpgStatus, setLpgStatus] = React.useState(true);
    const [gasStatus, setGasStatus] = React.useState(true);
    const [autoplay, setAutoplay] = React.useState(false);
    const [isTablet, setIsTablet] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(false);
    const [defaultPlan, setDefaultPlan] = React.useState('');
    const [defaultPhonePlan, setDefaultPhonePlan] = React.useState('');
    const [bbActionText, setBbActionText] = React.useState('Hide Plans');

    const toggleCheck = (serviceName) => {
        let check = itemInArray(serviceName);

        // when service in array
        if (check) {
            setIsChecked(true);
            
            var index = selectedServices.indexOf(serviceName);
            var bb_index = broadbandServices.indexOf(serviceName);

            //if found in array, remove
            if (index > -1 ) {
                if (serviceName !== 'electricity') {
                    let newServices = [...selectedServices];
                    newServices.splice(index, 1);
                    setSelectedServices(newServices);
                }
            } 

            if (bb_index > -1) {
                if (serviceName === "broadband") {
                    setBroadbandServices([]);

                    const toggleButton = document.querySelector('.service-box__toggle--phone');
                    toggleButton.click();

                } else {
                    let newBroadband = [...broadbandServices];
                    newBroadband.splice(bb_index, 1);
                    setBroadbandServices(newBroadband);
                }
            }
        } else {
            // when service not in array
            if (serviceName === 'gas' && gasStatus && (!itemInArray('lpg'))) {
                setSelectedServices([...selectedServices, serviceName]);
            }
            if ((!itemInArray('gas')) && serviceName === 'lpg' && lpgStatus) {
                setSelectedServices([...selectedServices, serviceName]);
            }
            if (itemInArray('broadband') && serviceName === 'phone') {
                setBroadbandServices([...broadbandServices, 'phone']);
            } else if (broadbandStatus && serviceName === 'broadband') {
                setBroadbandServices([...broadbandServices, 'broadband']);
            } else if (serviceName !== 'phone' && serviceName !== 'broadband' && serviceName !== 'gas' && serviceName !== 'lpg') {
                setSelectedServices([...selectedServices, serviceName]);
            }
        }
    }

    const itemInArray = (item) => {
        if (selectedServices.indexOf(item) > -1) {
            return true;
        }
        if (broadbandServices.indexOf(item) > -1) {
            return true;
        } else {
            return false;
        }
    }

    const currentBroadbandStatus = () => {
        if (broadbandStatus) {
            return true;
        } else {
            return false;
        }
    }

    const resizeScreen = () => {
        if (window.innerWidth <= 768) {
            setIsTablet(false);
        } else {
            setIsTablet(false);
        }
    }

    const setBroadbandAction = (e) => {
        e.preventDefault();
        const toggleButton = document.querySelector('.service-box__toggle--broadband');
        toggleButton.click();

        if (bbActionText == 'Hide Plans') {
            setBbActionText('Show Plans');
        } 
        
        if (bbActionText == 'Show Plans') {
            setBbActionText('Hide Plans');
        }
    }

    const getBryteTui = () => {
        let queryAddress = props.values.address;
        let strtname = '';

        if (queryAddress.includes("/")) {
            let addressArray = queryAddress.split("/")[1].split(",");
            strtname = addressArray[0];
        } else if (queryAddress.includes(",")) {
            strtname = queryAddress.split(",")[0];
        }

        // start

        // const res = {"success":true,"data":[
        //     {
        //       "Key": "PULSE_UFB_300_GREY",
        //       "Title": "Everyday Fibre",
        //       "Connection": "300/100",
        //       "Price": "$95",
        //       "StandardRate": "$89",
        //       "Details": "Perfect for households with a few people streaming at the same time, who enjoy watching Netflix, listening to music, and skyping.",
        //       "AvgDownload": "300",
        //       "Upload": "100",
        //       "BroadbandIcon": "Uploads/Everyday-Fibre.png",
        //       "Recommended": 1,
        //       "SortOrder": 1
        //     },
        //     {
        //       "Key": "PULSE_UFB_STARTER_GREY",
        //       "Title": "Lite Fibre*",
        //       "Connection": "50/10",
        //       "Price": "$60*",
        //       "StandardRate": "61.74",
        //       "Details": "For smaller households that use the internet for sending emails, reading the news and the occasional Facebook use.",
        //       "AvgDownload": "50",
        //       "Upload": "10",
        //       "BroadbandIcon": "Uploads/Lite-Fibre.png",
        //       "Recommended": 0,
        //       "SortOrder": 2
        //     },
        //     {
        //       "Key": "PULSE_UFB_MAX_GREY",
        //       "Title": "Fibre Pro",
        //       "Connection": "Max/877",
        //       "Price": "$111",
        //       "StandardRate": "$96.52",
        //       "Details": "Maximum speed for households who don’t like to wait, perfect for if you have multiple people streaming or playing games online at the same time.",
        //       "AvgDownload": "877",
        //       "Upload": "496",
        //       "BroadbandIcon": "Uploads/Fibre-Pro.png",
        //       "Recommended": 0,
        //       "SortOrder": 3
        //     },
        //     {
        //         "Key": "PULSE_ADSL_GREY",
        //         "Title": "Starter ADSL",
        //         "Connection": "ADSL/VDSL",
        //         "Price": "$85",
        //         "StandardRate": "$73.91",
        //         "Details": "Unlimited internet data if your home has an ADSL/VDSL connection.",
        //         "AvgDownload": "ADSL/VDSL",
        //         "Upload": "",
        //         "BroadbandIcon": "Uploads/Fibre-Pro.png",
        //         "Recommended": 0,
        //         "SortOrder": 4
        //       }
        //   ],"error":{"title":"","message":""}};

        // let bryteData = res.data;
        
        // props.setBroadbandResults(bryteData);

        /* Temp Data 2 */
        axios.post("/home/getBroadbandResult", { streetName: strtname }, { timeout: 100000 })
        .then(res => {
            let bryteData = res.data.data;
            props.setBroadbandResults(bryteData);
        })
        .catch(error => console.error(error));
    }

    const setConnectionOption = (connectionOption) => {
        props.setConnectionOption(connectionOption)
    }

    const setPhonePlan=(phonePlan)=>{
        props.setPhonePlan(phonePlan)        
    }

    React.useEffect(() => {

        if (props.values.LPGDataFromDB instanceof Object === true) {
            setLpgStatus(true);
        } 

        getBryteTui();

        if (props.values.broadbandResult.length !== 0)  {
            setBroadbandStatus(true);

            // if type param is equal to broadband and broadband is available
            // add broadband to selected services
            if (type === 'broadband') {
                setBroadbandServices([...broadbandServices, 'broadband']);
            }
        } else {
            setBroadbandStatus(false);
        }   

        window.addEventListener("resize", resizeScreen);

        if (props.values.broadbandArray.includes('broadband')) {
            const toggleButton = document.querySelector('.service-box__toggle--broadband');
            toggleButton.click();
        }

        if (props.values.broadbandArray.includes('phone')) {
            const toggleButton2 = document.querySelector('.service-box__toggle--phone');
            toggleButton2.click();
        }

        return () => {
            window.removeEventListener("resize", resizeScreen);
        };
    }, []);

    React.useEffect(() => {
        if (props.values.gasRatesResult instanceof Object === true) {
            setGasStatus(true);
        }

    }, [props.values.gasRatesResult]);

    React.useEffect(() => {
        if (props.values.broadbandResult.length !== 0) {
            setBroadbandStatus(true);
        }
        
    }, [props.values.broadbandResult]);

    React.useEffect(() => {

        if (props.values.broadbandPlan.length > 0) {
            setDefaultPlan(props.values.broadbandPlan[0].plan);
        }

    }, [props.values.broadbandPlan]);

    React.useEffect(() => {

        if (props.values.confirmPhonePlan.length > 0) {
            setDefaultPhonePlan(props.values.confirmPhonePlan[0].title);
        }

    }, [props.values.confirmPhonePlan]);

    React.useEffect(() => {

        props.setBroadbandArray(broadbandServices);

    }, [broadbandServices]);

    React.useEffect(() => {

        props.setServicesArray(selectedServices);
        
    }, [selectedServices]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // React.useEffect(() => {

    //     console.log(props.values.LPGDataFromDB);
        
    // }, [props.values.LPGDataFromDB]);

    const CheckedIcon = () => (
        <svg className="broadband-item-checked" width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="28.5" cy="28" r="28" fill="#CAE2E1" />
            <path d="M39.591 21.25L24.341 36.5L17.4092 29.5682" stroke="white" strokeWidth="2.77273" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
       
    return (
        <div id="services">
            <h3>{props.forms.BuildYourPlanTitle}</h3>

            <div className="row " id="servicesRow">
                {/* {selectedServices}
                <div>
                    <pre>{JSON.stringify(props.values, null, 2)}</pre>
                </div> */}
                <div className="col-xs-12 col-md-12 col-lg-12 service-item" style={{display: 'none'}}>
                    <Card>
                        <CardActionArea>
                            <CardContent className={(itemInArray('electricity')) ? "toggled service-item-container" : "service-item-container"}>
                                <div className="service-item-wrapper">
                                    <div className="MuiCard-divider service-item-icon">
                                        {itemInArray('electricity') ?
                                            <ElectricityIcon />
                                        : <ElectricityIcon />}
                                    </div>
                                    <div className="service-item-body">
                                        <h4 className="h4">Electricity</h4>
                                        <ul className="hide-mobile">
                                            <li><p className="footnotes__text__description">Low price upfront</p></li>
                                            <li><p className="footnotes__text__description">No long term contracts</p></li>
                                            <li><p className="footnotes__text__description">No Mark Up on Network Services<sup>1</sup></p></li>
                                        </ul> 
                                    </div>
                                    {(itemInArray('electricity')) ? <span onClick={() => toggleCheck('electricity')} className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">
                                        <CheckedIcon />
                                    </span> : 
                                        <span onClick={() => toggleCheck('electricity')} className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">Select</span>}
                                </div>
                                <ul className="hide-desktop service-item-body-mobile">
                                    <li><p className="footnotes__text__description">Low price upfront</p></li>
                                    <li><p className="footnotes__text__description">No long term contracts</p></li>
                                    <li><p className="footnotes__text__description">No Mark Up on Network Services<sup>1</sup></p></li>
                                </ul> 
                                {/* Start Content Toggle */}
                                <span className="service-box__toggle" onClick={(e) => {
                                    e.preventDefault();
                                    const toggleBody = e.currentTarget.nextElementSibling;
                                    const svg = e.currentTarget.querySelector('svg');
                                    toggleBody.classList.toggle('service-box__toggle-body--show');
                                    svg.style.transform = svg.style.transform === 'rotate(180deg)' ? '' : 'rotate(180deg)';
                                    const label = e.currentTarget.querySelector('label');
                                    label.textContent = label.textContent === 'Show Rates' ? 'Hide Rates' : 'Show Rates';
                                }}>
                                    <label className="show-rates-label">Show Rates</label>
                                    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transition: 'transform 0.3s'}}>
                                        <path d="M1 0.5L5 4.5L9 0.5" stroke="#030904" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <div className="service-box__toggle-body">
                                    <BuildElectricity values={props.values} />
                                </div>
                                {/* End Content Toggle */}
                                {(itemInArray('electricity')) ? <span onClick={() => toggleCheck('electricity')} className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">
                                    <CheckedIcon />
                                </span> : 
                                        <span onClick={() => toggleCheck('electricity')} className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">Select</span>}
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </div>

                <div className="col-xs-12 col-md-12 col-lg-12 service-item">
                    <Card>
                        <CardActionArea disabled={!(props.values.LPGDataFromDB && Object.keys(props.values.LPGDataFromDB).length && props.values.LPGDataFromDB !== 'undefined')}>
                            <CardContent className={(itemInArray('lpg')) ? "toggled service-item-container" : "service-item-container"}>
                                <div className="service-item-wrapper">
                                    <div className="MuiCard-divider service-item-icon">
                                        {itemInArray('lpg') ?
                                            <LPGIcon />
                                        : <LPGIcon />}
                                    </div>
                                    <div className="service-item-body">
                                        <h4 className="h4">LPG</h4>
                                        <ul className="hide-mobile">
                                            <li><p className="footnotes__text__description">Receive our <strong>All Energy Discount</strong> when you add LPG to your account. Available when you have your electricity with us. </p></li>
                                        </ul> 
                                    </div>
                                    {(itemInArray('lpg')) ? <span onClick={() => toggleCheck('lpg')} className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">
                                        <CheckedIcon />
                                    </span> : 
                                        <span onClick={() => toggleCheck('lpg')} className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">Select</span>}
                                </div>
                                <ul className="hide-desktop service-item-body-mobile">
                                    <li><p className="footnotes__text__description">Receive our <strong>All Energy Discount</strong> when you add LPG to your account. Available when you have your electricity with us. </p></li>
                                </ul> 
                                {/* Start Content Toggle */}
                                <span className="service-box__toggle" onClick={(e) => {
                                    e.preventDefault();
                                    const toggleBody = e.currentTarget.nextElementSibling;
                                    const svg = e.currentTarget.querySelector('svg');
                                    toggleBody.classList.toggle('service-box__toggle-body--show');
                                    svg.style.transform = svg.style.transform === 'rotate(180deg)' ? '' : 'rotate(180deg)';
                                    const label = e.currentTarget.querySelector('label');
                                    label.textContent = label.textContent === 'Show Rates' ? 'Hide Rates' : 'Show Rates';
                                }}>
                                    <label className="show-rates-label">Show Rates</label>
                                    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transition: 'transform 0.3s'}}>
                                        <path d="M1 0.5L5 4.5L9 0.5" stroke="#030904" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <div className="service-box__toggle-body">
                                    {props.values.LPGDataFromDB && <BuildLPG 
                                                                     values={props.values}
                                                                     handleNoGstChange={props.handleNoGstChange} 
                                                                     noGst={props.noGst}  
                                                                   />}
                                </div>
                                {/* End Content Toggle */}
                                {(itemInArray('lpg')) ? <span onClick={() => toggleCheck('lpg')} className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">
                                    <CheckedIcon />
                                </span> : 
                                        <span onClick={() => toggleCheck('lpg')} className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">Select</span>}
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </div>

                <div className="col-xs-12 col-md-12 col-lg-12 service-item">
                    <Card>
                        <CardActionArea disabled={!props.values.gasRatesResult?.MyGasQuote}>
                            <CardContent className={(itemInArray('gas')) ? "toggled service-item-container" : "service-item-container"}>
                                <div className="service-item-wrapper">
                                    <div className="MuiCard-divider service-item-icon">
                                        {itemInArray('gas') ?
                                            <NaturalGasIcon />
                                        : <NaturalGasIcon />}
                                    </div>
                                    <div className="service-item-body">
                                        <h4 className="h4">Natural Gas</h4>
                                        <ul className="hide-mobile">
                                            <li><p className="footnotes__text__description">Receive our <strong>All Energy Discount</strong> when you add Natural Gas to your account. Available when you have your electricity with us. </p></li>
                                        </ul> 
                                    </div>
                                    {(itemInArray('gas')) ? <span onClick={() => toggleCheck('gas')} className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">
                                        <CheckedIcon />
                                    </span> : 
                                        <span onClick={() => toggleCheck('gas')} className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">Select</span>}
                                </div>
                                <ul className="hide-desktop service-item-body-mobile">
                                    <li><p className="footnotes__text__description">Receive our <strong>All Energy Discount</strong> when you add Natural Gas to your account. Available when you have your electricity with us. </p></li>
                                </ul> 
                                {/* Start Content Toggle */}
                                <span className="service-box__toggle" onClick={(e) => {
                                    e.preventDefault();
                                    const toggleBody = e.currentTarget.nextElementSibling;
                                    const svg = e.currentTarget.querySelector('svg');
                                    toggleBody.classList.toggle('service-box__toggle-body--show');
                                    svg.style.transform = svg.style.transform === 'rotate(180deg)' ? '' : 'rotate(180deg)';
                                    const label = e.currentTarget.querySelector('label');
                                    label.textContent = label.textContent === 'Show Rates' ? 'Hide Rates' : 'Show Rates';
                                }}>
                                    <label className="show-rates-label">Show Rates</label>
                                    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transition: 'transform 0.3s'}}>
                                        <path d="M1 0.5L5 4.5L9 0.5" stroke="#030904" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <div className="service-box__toggle-body">
                                    {gasStatus == true && <BuildGas values={props.values} 
                                                                     handleNoGstChange={props.handleNoGstChange} 
                                                                     noGst={props.noGst}  
                                                                   />}
                                </div>
                                {/* End Content Toggle */}
                                {(itemInArray('gas')) ? <span onClick={() => toggleCheck('gas')} className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">
                                <CheckedIcon />
                                </span> : 
                                        <span onClick={() => toggleCheck('gas')} className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services">Select</span>}
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </div>

                <div className="col-xs-12 col-md-12 col-lg-12 service-item">
                    <Card>
                        <CardActionArea disabled={!currentBroadbandStatus()}>
                            <CardContent className="service-item-container">
                                <div className="service-item-wrapper">
                                    <div className="MuiCard-divider service-item-icon service-item-icon--broadband">
                                        {itemInArray('broadband') ?
                                            <BroadbandIcon />
                                        : <BroadbandIcon />}
                                    </div>
                                    <div className="service-item-body">
                                        <h4 className="h4">Broadband</h4>
                                        <ul className="hide-mobile">
                                            <li><p className="footnotes__text__description">Unlimited broadband. Available when you have your electricity with us.</p></li>
                                        </ul> 
                                    </div>
                                    
                                    {props.values.broadbandArray.includes('broadband') ? <span onClick={(e) => setBroadbandAction(e)} className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services broadband-link service-box__toggle--broadband-hide">{bbActionText}</span> : 
                                    <span onClick={(e) => {
                                        e.preventDefault();
                                        const toggleButton = document.querySelector('.service-box__toggle--broadband');
                                        toggleButton.click();
                                        const linkText = e.currentTarget;

                                        console.log(linkText.textContent)

                                        if (linkText.textContent == 'Hide Plans') {
                                            linkText.textContent = 'Hide Plans';
                                        } 
                                        
                                        if (linkText.textContent == 'Show Plans'){
                                            linkText.textContent = 'Show Plans';
                                        }
                                        
                                    }} className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services broadband-link">Show Plans</span>
                                    }
                                </div>
                                <ul className="hide-desktop service-item-body-mobile">
                                    <li><p className="footnotes__text__description">Unlimited broadband. Available when you have your electricity with us.</p></li>
                                </ul> 
                                {/* Start Content Toggle */}
                                <span className="service-box__toggle service-box__toggle--broadband" onClick={(e) => {
                                    e.preventDefault();
                                    const toggleBody = e.currentTarget.nextElementSibling;
                                    const svg = e.currentTarget.querySelector('svg');
                                    toggleBody.classList.toggle('service-box__toggle-body--show');
                                    svg.style.transform = svg.style.transform === 'rotate(180deg)' ? '' : 'rotate(180deg)';
                                    const label = e.currentTarget.querySelector('label');
                                    label.textContent = label.textContent === 'Show Broadband Plans' ? 'Hide Broadband Plans' : 'Show Broadband Plans';
                                    const linkText = document.querySelector('.broadband-link'); // Correctly select the element with broadband-link class
                                    linkText.textContent = linkText.textContent === 'Show Plans' ? 'Hide Plans' : 'Show Plans';
                                }}>
                                    <label className="show-rates-label">Show Broadband Plans</label>
                                    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transition: 'transform 0.3s'}}>
                                        <path d="M1 0.5L5 4.5L9 0.5" stroke="#030904" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <div className="service-box__toggle-body">
                                    <BuildBroadband 
                                        values={props.values}
                                        setBBPlan={props.setBBPlan}
                                        defaultPlan={defaultPlan}
                                        setConnectionOption={setConnectionOption}
                                        setPhonePlan={setPhonePlan}
                                        toggleCheck={toggleCheck}
                                    />
                                    <div className="service-broadband-terms" dangerouslySetInnerHTML={{__html: props.values.broadbandTerms}}></div>
                                </div>
                                {/* End Content Toggle */}
                                {/* {props.values.broadbandArray.includes('broadband') ? <span className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services broadband-link--selected">
                                    <CheckedIcon />
                                </span> : <span onClick={(e) => {
                                        e.preventDefault();
                                        const toggleButton = document.querySelector('.service-box__toggle--broadband');
                                        toggleButton.click();
                                        const linkText = e.currentTarget;
                                        linkText.textContent = linkText.textContent === 'Show Plans' ? 'Hide Plans' : 'Show Plans';
                                    }} className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services broadband-link">Show Plans</span>} */}
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </div>

                <div className="col-xs-12 col-md-12 col-lg-12 service-item">
                    <Card>
                        <CardActionArea disabled={!itemInArray('broadband') || props.values.connectionOption === "BYO Modem"}>
                            <CardContent className={"service-item-container"}>
                                <div className="service-item-wrapper">
                                    <div className="MuiCard-divider service-item-icon service-item-icon--broadband">
                                        {itemInArray('phone') && itemInArray('broadband') && props.values.connectionOption !== "BYO Modem" ?
                                            <PhoneIcon />
                                        : <PhoneIcon />}
                                    </div>
                                    <div className="service-item-body">
                                        <h4 className="h4">Phone</h4>
                                        <ul className="hide-mobile">
                                        <li><p className="footnotes__text__description">Unlimited calling plans. Available when you have broadband with us.
                                        </p></li>
                                        </ul> 
                                    </div>
                                    <span onClick={(e) => {
                                        e.preventDefault();
                                        const toggleButton = document.querySelector('.service-box__toggle--phone');
                                        toggleButton.click();
                                        const linkText = document.querySelector('.phone-link-main');
                                        linkText.textContent = linkText.textContent === 'Show Plans' ? 'Show Plans' : 'Hide Plans';
                                    }} 
                                    style={{visibility: !itemInArray('broadband') ? 'hidden' : 'visible'}}
                                    className="hide-mobile service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services phone-link phone-link-main">Show Plans</span>
                                </div>
                                <ul className="hide-desktop service-item-body-mobile">
                                <li><p className="footnotes__text__description">Unlimited calling plans. Available when you have broadband with us.
                                </p></li>
                                </ul> 
                                {/* Start Content Toggle */}
                                <span className="service-box__toggle service-box__toggle--phone" onClick={(e) => {
                                    e.preventDefault();
                                    const toggleBody = e.currentTarget.nextElementSibling;
                                    const svg = e.currentTarget.querySelector('svg');
                                    toggleBody.classList.toggle('service-box__toggle-body--show');
                                    svg.style.transform = svg.style.transform === 'rotate(180deg)' ? '' : 'rotate(180deg)';
                                    const label = e.currentTarget.querySelector('label');
                                    label.textContent = label.textContent === 'Show Phone Plans' ? 'Hide Phone Plans' : 'Show Phone Plans';
                                    const linkText = document.querySelector('.phone-link');
                                    linkText.textContent = linkText.textContent === 'Show Plans' ? 'Hide Plans' : 'Show Plans';
                                }}>
                                    <label className="show-rates-label">Show Phone Plans</label>
                                    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transition: 'transform 0.3s'}}>
                                        <path d="M1 0.5L5 4.5L9 0.5" stroke="#030904" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <div className="service-box__toggle-body">
                                    <BuildPhone 
                                        values={props.values}
                                        defaultPhonePlan={defaultPhonePlan}
                                        toggleCheck={toggleCheck}
                                        setPhonePlan={setPhonePlan}
                                        setBroadbandArray={props.setBroadbandArray}
                                        confirmPhonePlan={props.values.confirmPhonePlan}
                                    />
                                    <div className="service-broadband-terms">
                                        <p className="footnotes__text__description">
                                            <span>
                                                <a rel="noopener" href="https://www.greypowerelectricity.co.nz/fair-use-policy/" target="_blank">
                                                Fair Use Policy applies
                                                </a>. Home phone plan rates include GST.<br />
                                            </span>
                                            <sup>4</sup> For a list of countries <a className="ss-broken" href="javascript:;" onClick={handleClickOpen}>click here</a>.
                                        </p>
                                        <div dangerouslySetInnerHTML={{__html: props.values.phoneTerms}}></div>
                                    </div>
                                </div>
                                {/* End Content Toggle */}
                                <span onClick={(e) => {
                                    e.preventDefault();
                                    const toggleButton = document.querySelector('.service-box__toggle--phone');
                                    toggleButton.click();
                                    const linkText = e.currentTarget;
                                    linkText.textContent = linkText.textContent === 'Show Plans' ? 'Hide Plans' : 'Show Plans';
                                }} className="mt-4 hide-desktop service-item-link MuiButtonBase-root MuiButton-root MuiButton-outlined Services phone-link">Show Plans</span>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </div>

        </div> 
         
            <BackNextButtons
                values={props.values}
                nextStep={props.nextStep}
                prevStep={props.prevStep}
                id="Services"/>
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} className="diaolog-box plan-rates-modal">
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    <p className="diaolog-box-subheading" style={{color:'#000000'}}>Australia, Argentina, Canada, China, Cyprus, France, Germany, Hong Kong, India, Japan, Korea Republic, Luxembourg, Mexico, Netherlands, Pakistan, Singapore, South Africa, Switzerland, Taiwan, United Kingdom, USA.</p>
                </DialogTitle>
            </Dialog>
        </div>
    );
}
